<template>
  <div class="Container" v-if="UserAccess == 'DoNotShowThisPage'">
    <br />
    <h2 class="ViewHeading">AG Washbasin Units</h2>
    <b-row
      ><b-col>
        <h4>{{ this.selectedlocation }}</h4>
      </b-col></b-row
    >
    <div v-if="profileportal === 'HCU'">
      <DashInnerHCU />
    </div>
    <div v-if="profileportal === 'AGS' || profileportal === 'Admin'">
      <DashInnerAGS />
    </div>
    <div>
      <DashMichael />
    </div>
  </div>
</template>

<script>
import DashInnerAGS from "@/components/DashboardAGS";
import DashInnerHCU from "@/components/DashboardHCU";
import store from "../store";
// import axios from "axios";
import DashMichael from "@/components/DashboardMichael";

export default {
  components: {
    DashInnerAGS,
    DashInnerHCU,
    DashMichael,
  },
  computed: {},

  mounted() {
    // if (localStorage.getItem("reloaded")) {
    //   // The page was just reloaded. Clear the value from local storage
    //   // so that it will reload the next time this page is visited.
    //   localStorage.removeItem("reloaded");
    // } else {
    //   // Set a flag so that we know not to reload the page twice.
    //   localStorage.setItem("reloaded", "1");
    //   location.reload();
    // }
    // let current = new Date();
    // let HistoryDate =
    //   current.getFullYear() +
    //   "-" +
    //   (current.getMonth() + 1) +
    //   "-" +
    //   current.getDate();
    // let HistoryTime =
    //   current.getHours() +
    //   ":" +
    //   current.getMinutes({ minimumIntegerDigits: 2 }) +
    //   ":" +
    //   current.getSeconds({ minimumIntegerDigits: 2, useGrouping: false });
    // let UserName = localStorage.getItem("fullname");
    // let EventHistory = "Logged In";
    // axios.get("https://www.cloudflare.com/cdn-cgi/trace").then((response) => {
    //   this.response = response.data;
    //   let UserIPAddress = this.response.substring(
    //     this.response.search("ip=") + 3,
    //     this.response.search("ts=") - 1
    //   );
    //   let sendUrl =
    //     "https://bg4rfm4uqd.execute-api.eu-west-2.amazonaws.com/" +
    // this.$environment + "/userhistory";
    //   let sendData = {
    //     UserName: UserName,
    //     UserIPAddress: UserIPAddress,
    //     HistoryDate: HistoryDate,
    //     HistoryTime: HistoryTime,
    //     HistoryNote: EventHistory,
    //   };
    //   let sendHeaders = this.$apikeyPost;
    //   axios
    //     .post(sendUrl, sendData, sendHeaders)
    //     .then((response) => {
    //       response;
    //     })
    //     .catch((err) => return err);
    // });
  },
  beforeMount() {
    this.themepref = store.state.themepref;
  },
  created() {
    this.$auth.renewTokens().catch((err) => {
      return err;
    });
  },

  data() {
    return {
      profileportal: null,
      Auth0loggedIn: false,
      profile: {},
      themepref: "dark",
      accessGroup: null,
      selectedlocation: localStorage.getItem("CurrentLocation"),
      UserAccess: "",
    };
  },
  methods: {
    handleLoginEvent(data) {
      this.profile = data.profile;
      this.Auth0loggedIn = data.Auth0loggedIn;
      this.profileportal = data.profileportal;
      this.themepref = data.themepref;
      this.accessGroup = data.accessGroup;
    },
  },
};
</script>
<style></style>
